import styled from 'styled-components'

export const Container = styled.div`
    max-width: 700px;
    margin: auto;
    min-height: 100%;
    padding: 1rem 0.5rem;
`